import Api from '@api/setMealManage'
import { addImageView } from '@core/utils'
import cls from 'classnames'
import { MagicInput, message, Select } from 'hljd'
import { toJS } from 'mobx'
import { inject, observer } from 'mobx-react'
import React, { useEffect, useState } from 'react'
import style from './style.module.less'
import { formatScenicSpotList } from './utils'

const { TextArea } = MagicInput

const TravelStroke = ({ sessionServiceStore }) => {
  const {
    itineraryList,
    changeItineraryList,
    handleDeleteItinerary,
    destinationCityId
  } = sessionServiceStore
  const [scenicSpotList, setScenicSpotList] = useState([])

  useEffect(
    () => {
      if (destinationCityId) {
        _queryScenicSpotList(destinationCityId)
      } else {
        message.info('请先选择旅拍目的地')
      }
    },
    [destinationCityId]
  )

  const handleDelete = index => {
    handleDeleteItinerary(index)
  }

  const onChangeContent = (e, index) => {
    const value = e.target.value
    changeItineraryList('describe', value, index)
  }

  const onChangeScenic = (e, index) => {
    const value = e.map(item => ({
      id: item,
      name: scenicSpotList.find(o => o.value == item)?.label,
      cover: scenicSpotList.find(o => o.value == item)?.cover
    }))
    changeItineraryList('spots', value, index)
  }

  // 验证存在目的地选择项
  const existDestinationCityId = () => {
    if (!destinationCityId) {
      return message.info('请先选择旅拍目的地')
    }
  }

  // 请求景点数据
  const _queryScenicSpotList = async markId => {
    const { data, success } = await Api.getScenicSpotWithCity({ markId })
    if (success) {
      setScenicSpotList(formatScenicSpotList(data))
    }
  }

  return (
    <>
      {itineraryList.map((item, index) => (
        <div key={index} className={style.travelStroke}>
          <div className={style.title}>
            <span>行程{index + 1}</span>
            <a onClick={() => handleDelete(index)}>删除</a>
          </div>
          <div className={style.textarea}>
            <TextArea
              style={{ minHeight: 120 }}
              onChange={e => onChangeContent(e, index)}
              value={item.describe}
              placeholder="请说明套餐包含的拍摄行程路线、取景地、交通、食宿等情况"
              maxLength={500}
              showCount
              countPosition="inner"
            />
          </div>
          {((!!scenicSpotList.length && destinationCityId) ||
            (!scenicSpotList.length && !destinationCityId)) && (
            <>
              <div className={style.scenicTitle}>
                行程取景地
                <span className={style.extra}>(该套餐可拍摄的景点/取景地)</span>
              </div>
              <div onClick={existDestinationCityId} className={style.select}>
                <Select
                  optionFilterProp="label"
                  value={toJS(item.spots).map(f => f?.id)}
                  options={scenicSpotList}
                  onChange={e => onChangeScenic(e, index)}
                  style={{ width: '100%' }}
                  mode="multiple"
                  placeholder="请输入(该景点须已关联本店案例)"
                />
              </div>
            </>
          )}
          <ul className={style.scenicList}>
            {toJS(item.spots).map(f => {
              const child = scenicSpotList.find(o => o.value == f.id)
              return (
                child && (
                  <li key={f.id} className={style.item}>
                    <img
                      className={style.image}
                      src={addImageView(child?.cover, 164, 164, 1)}
                      alt={child?.label}
                    />
                    <span
                      className={cls({
                        [style.name]: true,
                        'text-cut': true
                      })}
                    >
                      {child?.label}
                    </span>
                  </li>
                )
              )
            })}
          </ul>
        </div>
      ))}
    </>
  )
}

export default inject('sessionServiceStore')(observer(TravelStroke))
